// extracted by mini-css-extract-plugin
export default {"content":"author_content__nrGpB","sidebarDesktop":"author_sidebarDesktop__rMyuN","sidebarMobile":"author_sidebarMobile__tkdHK"};